import {
    ServiceRisksListQuery,
    ServiceRisksData,
    DefaultServiceRisksData,
    ServiceRisksCreationParams,
    ServiceRisksUpdateParams,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/service-risks';

export class ServiceRisksApi {
    public static async create(serviceRisks: ServiceRisksCreationParams): Promise<void> {
        await axios.post(BASE_URL, { serviceRisks });
    }

    public static async update(id: string, serviceRisks: ServiceRisksUpdateParams): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, { serviceRisks });
    }

    public static async updateDefault(serviceRisks: ServiceRisksUpdateParams): Promise<void> {
        await axios.put(`${BASE_URL}/default`, { serviceRisks });
    }

    public static async getList(params?: ServiceRisksListQuery): Promise<ServiceRisksData[]> {
        const res = await axios.get(BASE_URL, { params });

        return res.data.serviceRisks;
    }

    public static async getDefault(): Promise<DefaultServiceRisksData> {
        const res = await axios.get(BASE_URL);

        return res.data.defaultServiceRisks;
    }
}
